'use client';

import Link from '@/components/Link';
import {WHATSAPP_LINK} from '@/lib/landing/constants';
import {finalCtaContent} from '@/lib/landing/content';
import {FadeIn, SectionContainer} from './shared';

export function FinalCTA() {
  return (
    <section aria-labelledby="final-cta-heading" className="py-32 relative bg-kobra-dark border-y border-kobra-border-dark overflow-hidden">
      <div
        aria-hidden="true"
        className="absolute inset-0 bg-gradient-to-t from-kobra-navy via-transparent to-kobra-dark pointer-events-none"
      />
      <div
        aria-hidden="true"
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-[400px] w-[600px] rounded-full bg-kobra-accent opacity-[0.06] blur-[100px] pointer-events-none"
      />

      <SectionContainer className="max-w-4xl mx-auto text-center relative z-10">
        <FadeIn>
          <h2 id="final-cta-heading" className="text-3xl md:text-5xl font-bold text-white mb-6">
            {finalCtaContent.title}
          </h2>
          <p className="text-kobra-text-muted-light text-lg md:text-xl mb-4 max-w-2xl mx-auto leading-relaxed">
            {finalCtaContent.description}
          </p>
          <p className="text-kobra-text-muted text-sm mb-10 max-w-2xl mx-auto">
            {finalCtaContent.complement}
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noreferrer"
              className="bg-kobra-accent hover:bg-kobra-accent-hover text-white px-8 py-4 rounded-full font-bold text-lg transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-kobra-accent focus-visible:ring-offset-2 focus-visible:ring-offset-kobra-dark"
            >
              Solicitar demo
            </a>
            <Link
              href="#docs"
              className="bg-kobra-surface hover:bg-kobra-surface-elevated border border-kobra-border-dark text-white px-8 py-4 rounded-full font-bold text-lg transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-kobra-accent"
            >
              Ver documentación API
            </Link>
          </div>
        </FadeIn>
      </SectionContainer>
    </section>
  );
}
